import React, { useEffect, useContext, useState } from 'react'

import { getBackendData } from '../../api/api'
import { ISwapVolumeByChain } from '../../api/interfaces'
import { IChart } from '../../components/Chart/interface'
import LoadingChart from '../../components/LoadingIcon/Loading'
import ChartPage from '../../pages/ChartPage/ChartPage'
import { colors } from '../../const'
import { useChartData } from '../../hooks/useChartData'

async function getSwapVolumeByChainConfig(color: string, inverseColor: string, timeframe: string) {
	const chartData = (await getBackendData('thorchain', 'tc_swap_volume_by_chain', timeframe)) as ISwapVolumeByChain[]
	const btcData = chartData.filter((row) => row.BLOCKCHAIN === 'BTC')
	const ethData = chartData.filter((row) => row.BLOCKCHAIN === 'ETH')
	const bchData = chartData.filter((row) => row.BLOCKCHAIN === 'BCH')
	const avaxData = chartData.filter((row) => row.BLOCKCHAIN === 'AVAX')
	const baseData = chartData.filter((row) => row.BLOCKCHAIN === 'BASE')
	const dogeData = chartData.filter((row) => row.BLOCKCHAIN === 'DOGE')
	const ltcData = chartData.filter((row) => row.BLOCKCHAIN === 'LTC')
	const atomData = chartData.filter((row) => row.BLOCKCHAIN === 'GAIA')
	const tcData = chartData.filter((row) => row.BLOCKCHAIN === 'THOR')
	const bscData = chartData.filter((row) => row.BLOCKCHAIN === 'BSC')
	const xrpData = chartData.filter((row) => row.BLOCKCHAIN === 'XRP')
	const tronData = chartData.filter((row) => row.BLOCKCHAIN === 'TRON')
	const zecData = chartData.filter((row) => row.BLOCKCHAIN === 'ZEC')

	const series1 = btcData.map((element: ISwapVolumeByChain) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.VOLUME_USD }
	})
	const series2 = ethData.map((element: ISwapVolumeByChain) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.VOLUME_USD }
	})
	const series3 = bchData.map((element: ISwapVolumeByChain) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.VOLUME_USD }
	})
	const series4 = avaxData.map((element: ISwapVolumeByChain) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.VOLUME_USD }
	})
	const series5 = baseData.map((element: ISwapVolumeByChain) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.VOLUME_USD }
	})
	const series6 = dogeData.map((element: ISwapVolumeByChain) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.VOLUME_USD }
	})
	const series7 = ltcData.map((element: ISwapVolumeByChain) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.VOLUME_USD }
	})
	const series8 = atomData.map((element: ISwapVolumeByChain) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.VOLUME_USD }
	})
	const series9 = tcData.map((element: ISwapVolumeByChain) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.VOLUME_USD }
	})
	const series11 = bscData.map((element: ISwapVolumeByChain) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.VOLUME_USD }
	})
	const series10 = btcData.map((element: ISwapVolumeByChain) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.TOTAL_VOL_USD_CUMULATIVE }
	})
	const series12 = xrpData.map((element: ISwapVolumeByChain) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.VOLUME_USD }
	})
	const series13 = tronData.map((element: ISwapVolumeByChain) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.VOLUME_USD }
	})
	const series14 = zecData.map((element: ISwapVolumeByChain) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.VOLUME_USD }
	})
	const config: IChart[] = [
		{
			data: series10,
			strokeWidth: 2,
			name: 'CUMULATIVE',
			type: 'line',
			seriesGroup: ' [usd]',
			color: `${color}`,
			unitSymbol: '$'
		},

		{
			data: series1,
			strokeWidth: 2,
			name: 'BTC',
			type: 'bars',
			seriesGroup: '[usd]',
			color: `${colors[0]}`,
			unitSymbol: '$',
			barGroup: 'usd'
		},
		{
			data: series2,
			strokeWidth: 2,
			name: 'ETH',
			type: 'bars',
			seriesGroup: '[usd]',
			color: `${colors[1]}`,
			unitSymbol: '$',
			barGroup: 'usd'
		},
		{
			data: series9,
			strokeWidth: 2,
			name: 'THOR',
			type: 'bars',
			seriesGroup: '[usd]',
			color: `${colors[2]}`,
			unitSymbol: '$',
			barGroup: 'usd'
		},
		{
			data: series3,
			strokeWidth: 2,
			name: 'BCH',
			type: 'bars',
			seriesGroup: '[usd]',
			color: `${colors[3]}`,
			unitSymbol: '$',
			barGroup: 'usd'
		},
		{
			data: series4,
			strokeWidth: 2,
			name: 'AVAX',
			type: 'bars',
			seriesGroup: '[usd]',
			color: `${colors[4]}`,
			unitSymbol: '$',
			barGroup: 'usd'
		},
		{
			data: series11,
			strokeWidth: 2,
			name: 'BSC',
			type: 'bars',
			seriesGroup: '[usd]',
			color: `${colors[5]}`,
			unitSymbol: '$',
			barGroup: 'usd'
		},
		{
			data: series6,
			strokeWidth: 2,
			name: 'DOGE',
			type: 'bars',
			seriesGroup: '[usd]',
			color: `${colors[6]}`,
			unitSymbol: '$',
			barGroup: 'usd'
		},
		{
			data: series7,
			strokeWidth: 2,
			name: 'LTC',
			type: 'bars',
			seriesGroup: '[usd]',
			color: `${colors[7]}`,
			unitSymbol: '$',
			barGroup: 'usd'
		},
		{
			data: series8,
			strokeWidth: 2,
			name: 'ATOM',
			type: 'bars',
			seriesGroup: '[usd]',
			color: `${colors[8]}`,
			unitSymbol: '$',
			barGroup: 'usd'
		},
		{
			data: series5,
			strokeWidth: 2,
			name: 'BASE',
			type: 'bars',
			seriesGroup: '[usd]',
			color: `${colors[9]}`,
			unitSymbol: '$',
			barGroup: 'usd'
		},
		{
			data: series12,
			strokeWidth: 2,
			name: 'XRP',
			type: 'bars',
			seriesGroup: '[usd]',
			color: `${colors[10]}`,
			unitSymbol: '$',
			barGroup: 'usd'
		},
		{
			data: series13,
			strokeWidth: 2,
			name: 'TRON',
			type: 'bars',
			seriesGroup: '[usd]',
			color: `${colors[11]}`,
			unitSymbol: '$',
			barGroup: 'usd'
		},
		{
			data: series14,
			strokeWidth: 2,
			name: 'ZEC',
			type: 'bars',
			seriesGroup: '[usd]',
			color: `${colors[13]}`,
			unitSymbol: '$',
			barGroup: 'usd'
		}
	]
	return { config: config, latestValue: series1[series1.length - 1].y, latestValueDate: series1[series1.length - 1].x }
}

const SwapVolumeByChain = () => {
	const { dataSeries, timeframe, setTimeframe, isLoading, error, retry } = useChartData(getSwapVolumeByChainConfig)

	if (error) {
		return (
			<div style={{ padding: 40, textAlign: 'center' }}>
				<p>Error loading chart: {error}</p>
				<button onClick={retry}>Retry</button>
			</div>
		)
	}

	if (isLoading || dataSeries === undefined) {
		return <LoadingChart />
	}

	return (
		<ChartPage
			chartTitle="Swap Volume By Chain"
			chartDesc={`Daily swap volume attributed to each external chain (BTC, ETH, XRP, etc.). Volume is assigned to the chain of the pool involved.\nBSC includes both BSC and BNB.`}
			chartDescTitle="Metric Description"
			chartData={dataSeries.config}
			queryId="6665bbe1-097c-4cc2-be5f-4b01a2436511"
			timeframe={timeframe}
			setTimeframe={setTimeframe}
			hasHours={false}
			reverseLegend={true}
			sortByValueDesc={true}
		/>
	)
}

export default SwapVolumeByChain
